import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Maestros_GruposService } from '../../services/maestros_grupos';
import { Maestro_Grupos } from '../../models/generic/Maestro_Grupos';
import { Maestro_Grupos_Roles } from '../../models/generic/Maestro_Grupos_Roles';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { Item_Seleccion } from 'src/app/models/generic/Item_Seleccion';

@Component({
  selector: 'maestros-matrizaccesogrupos',
  templateUrl: './maestros-matrizaccesogrupos.component.html',
  styleUrls: ['./maestros-matrizaccesogrupos.component.scss']
})
export class MaestrosMatrizAccesoGruposComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<any>;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  columnasEncabezado: string[] = [];
  columnasEncabezadoSinAcciones: Item_Seleccion[] = [];
  columnasEncabezadoAgrupado: string[] = [];
  editandoRegistro: boolean = false;
  listaDatos: any[] = [];
  itemSeleccionadoGuardar: any;
  listaDatosCompletos: Maestro_Grupos_Roles[] = [];
  contadorGrupos: number = 0;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_GruposService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarRegistros();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      idGrupoMenu: [0],
      idRol: [0],
      lectura: [false],
      escritura: [false]
    });
  }
  ConsultarRegistros() {
    this.mostrarCargando = true;
    this.datosServices.Roles_Consultar()
              .subscribe((resp: Maestro_Grupos_Roles[]) =>{
                this.listaDatosCompletos = resp;
                this.reorganizarControles();
                this.recargarLista();
                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  reorganizarControles() {
    this.columnasEncabezado = [];
    this.columnasEncabezadoSinAcciones = [];
    this.columnasEncabezadoAgrupado = [];
    this.listaDatos = [];

    this.columnasEncabezadoAgrupado.push('rol');
    this.columnasEncabezado.push(`0-rol-lectura`);
    this.columnasEncabezado.push(`0-rol-escritura`);
    this.columnasEncabezadoSinAcciones.push(this.ItemExtensionRetorno(`0-rol-lectura`, ``));
    this.columnasEncabezadoSinAcciones.push(this.ItemExtensionRetorno(`0-rol-escritura`, ``));

    let contador: number = 1;
    for (let index = 0; index < this.listaDatosCompletos.length; index++) {
      const propiedad = this.listaDatosCompletos[index];
      let columnaEncabezadoAgrupado = this.columnasEncabezadoAgrupado.filter(x => x === propiedad.grupoMenu);
      if (columnaEncabezadoAgrupado.length === 0) {
        this.columnasEncabezadoAgrupado.push(propiedad.grupoMenu);
        this.columnasEncabezado.push(`${contador}-lectura`);
        this.columnasEncabezado.push(`${contador}-escritura`);

        this.columnasEncabezadoSinAcciones.push(this.ItemExtensionRetorno(`${contador}-lectura`, `lectura`));
        this.columnasEncabezadoSinAcciones.push(this.ItemExtensionRetorno(`${contador}-escritura`, `escritura`));

        contador += 1;
      }
    }
    this.contadorGrupos = contador;
    
    this.columnasEncabezado.push('acciones');
    
    let listaRoles: string[] = [];
    for (let index = 0; index < this.listaDatosCompletos.length; index++) {
      const propiedad = this.listaDatosCompletos[index];
      let rolEncabezado = listaRoles.filter(x => x === propiedad.rol);
      if (rolEncabezado.length === 0) {
        listaRoles.push(propiedad.rol);

        let itemDatos: any = {
          'rol': propiedad.rol,
          '0-rol-lectura': propiedad.rol,
          '0-rol-escritura': '',
          'idRol': propiedad.idRol,
          'acciones': '',
          'editando': false
        };

        let filtroGruposRol = this.listaDatosCompletos.filter(x => x.idRol === propiedad.idRol);
        for (let index2 = 0; index2 < filtroGruposRol.length; index2++) {
          let nombreContadorLectura: string = `${index2+1}-lectura`;
          let nombreContadorEscritura: string = `${index2+1}-escritura`;
          itemDatos[nombreContadorLectura] = filtroGruposRol[index2].lectura;
          itemDatos[nombreContadorEscritura] = filtroGruposRol[index2].escritura;
          itemDatos['idGrupo'] = filtroGruposRol[index2].idGrupoMenu;
        }

        this.listaDatos.push(itemDatos);
      }
    }
  }
  ItemExtensionRetorno(id: string, descripcion: string): Item_Seleccion {
    let itemRetorno: Item_Seleccion = new Item_Seleccion();
    itemRetorno.id = id;
    itemRetorno.descripcion = descripcion;
    return itemRetorno;
  }
  Editar(itemSeleccionado: any) {
    if (this.menuService.TienePermisoEscrituraEnMenu('MaestrosMatrizAccesoComponent')) {
      itemSeleccionado.editando = true;
      this.editandoRegistro = true;
    }
  }
  Guardar(itemSeleccionado: any) {
    this.itemSeleccionadoGuardar = itemSeleccionado;
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  CancelarEditar(itemSeleccionado: any) {
    itemSeleccionado.editando = false;
    this.editandoRegistro = false;
    this.ConsultarRegistros();
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.ActualizarRegistro();
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;

    console.log('ActualizarRegistro-Antes', this.itemSeleccionadoGuardar.idRol, this.listaDatosCompletos)
    let filtroGruposRol = this.listaDatosCompletos.filter(x => x.idRol === this.itemSeleccionadoGuardar.idRol);
    console.log('ActualizarRegistro-Despues', filtroGruposRol)
    for (let index2 = 0; index2 < filtroGruposRol.length; index2++) {
      this.form.get('idGrupoMenu').setValue(filtroGruposRol[index2].idGrupoMenu);
      this.form.get('idRol').setValue(this.itemSeleccionadoGuardar.idRol);
      this.form.get('lectura').setValue(this.itemSeleccionadoGuardar[`${index2+1}-lectura`]);
      this.form.get('escritura').setValue(this.itemSeleccionadoGuardar[`${index2+1}-escritura`]);

      this.datosServices.Roles_Actualizar(this.form.value)
      .subscribe((resp: RespuestaGenerica) =>{
        if ((index2+1) === filtroGruposRol.length) {
          this.mostrarCargando = false;
          this.editandoRegistro = false;
          this.ConsultarRegistros();
        }
      },
      (error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    }
  }
}
